import { render } from "./HospiceCare.vue?vue&type=template&id=701f01ac"
import script from "./HospiceCare.vue?vue&type=script&lang=js"
export * from "./HospiceCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__